import React, { useEffect, useState } from "react";
import "./quotes.css";
import { Link, useNavigate } from "react-router-dom";
import center from "../../assets/centerline.png";
import axios from "axios";
import { Helmet } from "react-helmet";

function Quotes({ selectedTool, setSelectedTool }) {
  const [values, setValues] = useState({
    app_id: 3,
    page_no: 0,
  });
  const [data, setData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [id, setId] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Quotes/category_list_by_app_id",
        values
      )
      .then((result) => {
        setData(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  useEffect(() => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Image/category_list_by_app_id",
        {
          app_id: 2,
          page_no: 0,
        }
      )
      .then((result) => {
        setDatas(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(()=>{
   setSelectedTool("/quotes")
  },[])
  return (
    <div className="qt-base" style={{ backgroundColor: "#B24C76" }}>
      <Helmet>
        <title>
          Heartfelt Motherhood Quotes - Celebrate the Beauty of Being a Mom
        </title>
        <meta
          name="description"
          content="Collection of heartwarming motherhood quotes that capture the strength, and beauty of being a mom. Find inspiration and joy in the journey of motherhood. "
        />
        <meta
          name="keywords"
          content="Motherhood quotes, Mother quotes, strong mother quotes"
        />
      </Helmet>
      <div className="qt-main">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Quotes</li>
            </ol>
          </nav>
        </div>
        <div className="qt-head">
          <h2>Quotes</h2>
          <h4>For Mom-to-Be & Little One</h4>
          <div className="line-container">
            <hr className="line" />
            <img src={center} alt="" className="center-image pr" />
            <hr className="line" />
          </div>
        </div>
        <div className="qt-body">
          <div className="img-qt">
            <h4 className="pr" id="text-pr">
              Image Quotes
            </h4>
            <div className="sub-qt">
              {datas?.map((item, index) => (
                // <Link
                //   style={{ textDecoration: "none" }}
                //   to={{
                //     pathname: "/imageqt",
                //   }}
                // >
                <h5
                  key={index}
                  onClick={() => {
                    setId(item.category_id);
                    navigate("image-quotes", {
                      state: { category_id: item.category_id },
                    });
                  }}
                >
                  {item.category_name}
                </h5>
                // </Link>
              ))}
            </div>
          </div>
          <div className="txt-qt">
            <h4 className="pr" id="text-pr">
              Text Quotes
            </h4>
            <div className="sub-qt">
              {data?.map((item, index) => (
                // <Link
                //   style={{ textDecoration: "none" }}
                //   to={{
                //     pathname: "/textqt",
                //     state: { id },
                //   }}
                // >
                <h5
                  key={index}
                  onClick={() => {
                    setId(item.category_id);
                    navigate("text-quotes", {
                      state: { category_id: item.category_id },
                    });
                  }}
                >
                  {item.category_name}
                </h5>
                // </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quotes;
